import { c as _c } from "react/compiler-runtime";
import './help-me-choose-answers.scss';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionCardsGroup } from '../../../molecules/selection-cards-group/selection-cards-group.tsx';
import africaImage from '../images/africa-help-me-choose.webp';
import asiaImage from '../images/asia-help-me-choose.webp';
import caribbeanImage from '../images/caribbean-help-me-choose.webp';
import southImage from '../images/south-help-me-choose.webp';
import { createAnswers } from '../utils/answers.ts';
export const HelpMeChooseRegion: React.FC = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["help-me"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [location, setLocation] = useQueryState("countries", parseAsString);
  let t1;
  if ($[1] !== location) {
    t1 = location ? [location] : [];
    $[1] = location;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [controlledLocation, setControlledLocation] = useState(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    const regionCategories = [{
      label: "africa",
      value: "africa",
      imageUrl: africaImage
    }, {
      label: "asia",
      value: "asia",
      imageUrl: asiaImage
    }, {
      label: "caribbean",
      value: "caribbean",
      imageUrl: caribbeanImage
    }, {
      label: "southAmerica",
      value: "southAmerica",
      imageUrl: southImage
    }];
    t2 = createAnswers("region", regionCategories);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const regionAnswers = t2;
  let t3;
  if ($[4] !== setLocation) {
    t3 = nextValues => {
      const value = nextValues && nextValues.length > 0 ? nextValues[0] : null;
      const isChecked = !!value;
      if (isChecked) {
        setLocation(value);
      }
      if (!isChecked) {
        setLocation(null);
      }
      setControlledLocation(isChecked ? [value] : []);
    };
    $[4] = setLocation;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCheckboxChange = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("regionAnswers.groupLabel");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== controlledLocation || $[9] !== handleCheckboxChange || $[10] !== t4) {
    t5 = <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center"><SelectionCardsGroup cards={regionAnswers} selectionMode="single" value={controlledLocation} label={t4} onChange={handleCheckboxChange} /></div>;
    $[8] = controlledLocation;
    $[9] = handleCheckboxChange;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};